import { useContext } from "react";
import {
  SMART_CHARGING_ADD_EV_PATHS,
  SMART_CHARGING_OVERVIEW_PATHS,
  SMART_CHARGING_ONBOARDING_PATHS,
  SMART_CHARGING_COMPATIBILITY_PATHS,
} from "src/consts/Paths/SmartCharging";
import { ThemeValues } from "../ThemeUsage/theme";
import { ThemeContext } from "../ThemeUsage/ThemeUsage";
import SmartChargingStart from "src/pages/SmartCharging";
import Failed from "src/pages/SmartCharging/AddEv/Failed";
import Terms from "src/pages/SmartCharging/CompCheck/Terms";
import Model from "src/pages/SmartCharging/CompCheck/Model";
import Success from "src/pages/SmartCharging/AddEv/Success";
import Intro from "src/pages/SmartCharging/Onboarding/Intro";
import AddEvStart from "src/pages/SmartCharging/AddEv/Start";
import { Route, Routes, useLocation } from "react-router-dom";
import Status from "src/pages/SmartCharging/CompCheck/Status";
import Details from "src/pages/SmartCharging/Overview/Details";
import { Container, Grid, Stack, useTheme } from "@mui/material";
import Connecting from "src/pages/SmartCharging/Onboarding/Connecting";
import AddWallboxStart from "src/pages/SmartCharging/Onboarding/Start";
import { SMART_CHARGING_ROUTES } from "src/consts/Paths/SmartCharging";
import ModelSearch from "src/pages/SmartCharging/CompCheck/ModelSearch";
import OverviewStart from "src/pages/SmartCharging/Overview/OverviewStart";
import Compatibility from "src/pages/SmartCharging/CompCheck/Compatibility";
import ConnectConfirm from "src/pages/SmartCharging/Onboarding/ConnectConfirm";
import AddEvProgressBar from "../ProgressBar/MicroFrontend/SmartCharging/AddEv";
import ConnectingError from "src/pages/SmartCharging/Onboarding/ConnectingError";
import CompatibilitySale from "src/pages/SmartCharging/CompCheck/CompabilitySale";
import BrandItemThemeChanger from "../BrandIconThemeChanger/BrandIconThemeChanger";
import OnboardingSlider from "src/pages/SmartCharging/Onboarding/OnboardingSlider";
import ConnectingSuccess from "src/pages/SmartCharging/Onboarding/ConnectingSuccess";
import ManufacturerSearch from "src/pages/SmartCharging/CompCheck/ManufacturerSearch";
import OverviewProgressBar from "../ProgressBar/MicroFrontend/SmartCharging/Overview";
import CompatibilitySuccess from "src/pages/SmartCharging/CompCheck/CompatibilitySuccess";
import AuthenticationCallback from "src/pages/SmartCharging/AddEv/AuthenticationCallback";
import AddWallboxProgressBar from "../ProgressBar/MicroFrontend/SmartCharging/AddWallbox";
import CompatibilityProgressBar from "../ProgressBar/MicroFrontend/SmartCharging/Compatibility";
import FooterLinks from "../Footer/FooterLinks";

const SmarCharging = () => {
  const theme = useTheme();
  const { pathname } = useLocation();
  const themeName = useContext(ThemeContext);
  const isUserSelectEnabled = themeName !== ThemeValues.lichtblick;

  return (
    <Stack
      sx={{
        minHeight: "100vh",
        background: theme.palette.background.default,
        userSelect: isUserSelectEnabled ? undefined : "none",
      }}
    >
      <Container
        sx={{
          p: 4,
          flexGrow: 1,
          marginTop: { xs: 0, sm: 12 },
        }}
      >
        <Grid container>
          <Grid item xs={12} sm={4}>
            <Stack gap="50px">
              {SMART_CHARGING_COMPATIBILITY_PATHS.includes(pathname) && (
                <CompatibilityProgressBar />
              )}

              {SMART_CHARGING_ONBOARDING_PATHS.includes(pathname) && (
                <AddWallboxProgressBar />
              )}

              {SMART_CHARGING_OVERVIEW_PATHS.includes(pathname) && (
                <OverviewProgressBar />
              )}

              {SMART_CHARGING_ADD_EV_PATHS.includes(pathname) && (
                <AddEvProgressBar />
              )}
            </Stack>
          </Grid>

          <Stack
            sx={{
              display: { xs: "flex", sm: "none" },
              justifyContent: "center",
              width: "100%",
            }}
          >
            <BrandItemThemeChanger />
          </Stack>

          <Grid item xs={12} sm={8} sx={{ paddingLeft: { sm: 5, md: 20 } }}>
            <Routes>
              <Route
                element={<SmartChargingStart />}
                path={SMART_CHARGING_ROUTES.START}
              />
              <Route
                element={<Compatibility />}
                path={SMART_CHARGING_ROUTES.COMPATIBILITY}
              />
              <Route
                element={<CompatibilitySale />}
                path={SMART_CHARGING_ROUTES.COMPATIBILITY_SALE}
              />
              <Route element={<Model />} path={SMART_CHARGING_ROUTES.MODEL} />
              <Route element={<Terms />} path={SMART_CHARGING_ROUTES.TERMS} />
              <Route element={<Status />} path={SMART_CHARGING_ROUTES.STATUS} />

              <Route
                element={<ManufacturerSearch />}
                path={SMART_CHARGING_ROUTES.MANUFACTURER_SEARCH}
              />
              <Route
                element={<ModelSearch />}
                path={SMART_CHARGING_ROUTES.MODEL_SEARCH}
              />

              <Route
                element={<CompatibilitySuccess />}
                path={SMART_CHARGING_ROUTES.COMPATIBILITY_SUCCESS}
              />
              <Route
                element={<CompatibilitySuccess />}
                path={SMART_CHARGING_ROUTES.COMPATIBILITY_SUCCESS}
              />
              <Route
                element={<AddWallboxStart />}
                path={SMART_CHARGING_ROUTES.ADD_WALLBOX_START}
              />
              <Route element={<Intro />} path={SMART_CHARGING_ROUTES.INTRO} />
              <Route
                element={<ConnectConfirm />}
                path={SMART_CHARGING_ROUTES.CONNECT_CONFIRM}
              />
              <Route
                element={<Connecting />}
                path={SMART_CHARGING_ROUTES.CONNECTING}
              />
              <Route
                element={<ConnectingSuccess />}
                path={SMART_CHARGING_ROUTES.CONNECTING_SUCCESS}
              />
              <Route
                element={<ConnectingError />}
                path={SMART_CHARGING_ROUTES.CONNECTING_ERROR}
              />
              <Route
                element={<OnboardingSlider />}
                path={SMART_CHARGING_ROUTES.ONBOARDING_SLIDER}
              />

              <Route
                element={<OverviewStart />}
                path={SMART_CHARGING_ROUTES.OVERVIEW_START}
              />
              <Route
                element={<Details />}
                path={SMART_CHARGING_ROUTES.OVERVIEW_DETAILS}
              />

              <Route
                element={<AddEvStart />}
                path={SMART_CHARGING_ROUTES.ADD_EV_START}
              />

              <Route
                element={<AuthenticationCallback />}
                path={SMART_CHARGING_ROUTES.ADD_EV_ONBOARDING_CALLBACK}
              />

              <Route
                element={<Success />}
                path={SMART_CHARGING_ROUTES.ADD_EV_SUCCESS}
              />

              <Route
                element={<Failed />}
                path={SMART_CHARGING_ROUTES.ADD_EV_FAILED}
              />
            </Routes>
          </Grid>
        </Grid>
      </Container>
      <FooterLinks />
    </Stack>
  );
};

export default SmarCharging;
